// Vendor
import { createAction, props } from '@ngrx/store';
export const setFundChartSecuritylistName = createAction('[Fund Chart] Set security list name', props());
